<template>
    <div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="row">
        <div class="col-4">
            <div class="search-container">
              <tl-search @change="filterData($event)" :placeholder="'Search Employee Name'" />
            </div>
        </div>
        <div class="col-4">
            
        </div>
        <div class="col-4">
          <div class="align-right" :disabled="!addUserValue">
            <div class="add-new-icon-document" ref="permissionUser" @click="createAcc()">
              <img src="@/assets/circle-cross.svg" alt />
              <span class="add-new">Add User Account</span>
            </div>
          </div>      
        </div>
      </div>
      <div class="margintop-20" v-if="userList.length">{{ employeePageCount }}</div>
      <div class="margintop-20">
          <data-table
            :columns="employeeTableColumns"
            :tableData="userList"
            :checkbox="false"
            :withForm="false"
            :showhistory="false"
            :showdelete="false"
            :showedit="false"
            class="data-table-scroll"
          >
            <template v-slot:rowcontent="slotprops">
              <p
                v-if="slotprops.value.column.key=='name'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key=='email'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <!-- <p
                v-if="slotprops.value.column.key=='employee_code'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p> -->
              <!-- <p
                v-if="slotprops.value.column.key=='phoneNumber'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p> -->
              <p
                v-if="slotprops.value.column.key=='userRole'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key=='permission'"
              >
                <img
                src="@/assets/edit.svg"
                class="cross-circle-img"
                @click="editPermission(slotprops.value.record)"
                alt="actionIcon"
                style="margin:0px 10px;"
                :disabled="!addUserPermissionValue"
                />
                <img
                src="@/assets/eye-img.svg"
                class="cross-circle-img"
                @click="viewPermission(slotprops.value.record)"
                alt="actionIcon"
                />
              </p>
              <p
                v-if="slotprops.value.column.key=='is_active'"
              > {{slotprops.value.record[slotprops.value.column.key] ? "Active" : "Deactivated"}} 
              </p>
              <div
                class="action-section"
                v-if="slotprops.value.column.key=='action'"
              >
                <img
                src="@/assets/group-2.png"
                class="pointer-cursor"
                @click="dropdown(slotprops.value.record)"
                alt="actionIcon"
                />
                <ul
                  class="action-menu"
                  v-show="userList[slotprops.value.index].showDropDown"
                  >
                    <li>
                      <span
                        v-if="slotprops.value.record['is_active']==false"
                        class
                        @click="activated(slotprops.value.record)"
                        >Activated</span
                      >
                      <span
                        v-else
                        class
                        @click="deactivated(slotprops.value.record)"
                        >Deactivated</span
                      >
                    </li>
                    <li>
                      <span class @click="onForgotPasswordClick(slotprops.value.record)"
                        >Forgot Password</span
                      >
                    </li>
                  </ul>
              </div>
            </template>
          </data-table>
          <!-- Create User Account popup model -->
          <pop-up-window
            v-if="addUserAccount"
            @back="addUserAccount = !addUserAccount"
            header="Create User Account">
            <template v-slot:content>
              <create-user-account @back="addUserAccount = !addUserAccount"></create-user-account>
            </template>
          </pop-up-window>
          <!-- Create User Account End here  -->

          <!-- Edit User Role Permission popup model -->
          <pop-up-window
            v-if="editUserRole"
            @back="editUserRole = !editUserRole"
            header="Screen Permission">
            <template v-slot:content>
              <edit-user-role :userRole="userRoleData" @back="editUserRole = !editUserRole"></edit-user-role>
            </template>
          </pop-up-window>
          <!-- Edit User Role Permission End here  -->

          <!-- Screen Permission View popup model -->
          <pop-up-window
            v-if="permissionViewModel"
            @back="permissionViewModel = !permissionViewModel"
            header="Screen Permission">
            <template v-slot:content>
              <permission-view :userRole="userRoleData" @back="permissionViewModel = !permissionViewModel"></permission-view>
            </template>
          </pop-up-window>
          <!-- Screen Permission View End here  -->
        </div>
        <div v-if="userList.length">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        Previous 
      </button>
      <span> {{ currentPage }} of {{ totalPages }} </span>
      <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
        Next 
      </button>
    </div>

      <form v-on:submit.prevent="sendLink()">
            <div class="modal" v-show="showResetPasswordModal">
              <div class="modal-content">
                <toast-message
                  :message="forgotPasswordErrorMessage"
                  type="error"
                  :isToastEnable="forgotPasswordToast"
                  @close="(val) => forgotPasswordToast = val"
                />
                <p class="header header3 forgpass">
                  <span class="text">Forgot Password</span>
                </p>
                <span
                  class="label"
                >Enter your User name and we will send you the link to reset your password.</span>
                <br />
                <input
                  class="input-field"
                  autofocus="autofocus"
                  type="email"
                  v-model="forgotPasswordUserIdentity"
                  name="forgot password"
                  placeholder="User name"
                  id="forgot password"
                  v-validate="`required_if:${forgotPasswordUserIdentity.length}`"
                  @onValueChange="sendLink"
                />
                <span
                  class="errorMessage"
                  v-show="errors.has('forgot password')"
                >The forgot password field must be a valid user name</span>
                <div class="popup-btns">
                  <a @click="cancel" class="cursor btn secondary">Cancel</a>
                  <btn
                    :disabled="errors.has('forgot password') || !(forgotPasswordUserIdentity.length)"
                    text="Send reset link"
                    type="primary"
                    @click="sendLink"
                  ></btn>
                </div>
              </div>
            </div>
          </form>
          <pop-up-message
            v-if="showSuccessMsg"
            :message="`
              Reset password link has been sent to registered email id. Please reset your password.`"
            btnText="OK"
            @back="ok"
          ></pop-up-message>

      <footer>
        <popup-bottom-container class="position-fixed marginleft">
            <btn-grp slot="end">
              <btn text="Back" type="secondary" @click="backToWelcomeScreen" />
            </btn-grp>
        </popup-bottom-container>
      </footer>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import CreateUserAccount from "./createUserAccount.vue";
import EditUserRole from "./editUserRole.vue";
import PermissionView from "./permissionView.vue"; 

export default {
  components: {
    CreateUserAccount,
    EditUserRole,
    PermissionView
  },
  props: {
    addUserValue: {
      type: Boolean,
      default: false
    },
    addUserPermissionValue: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      currentPage: 1,
      totalPages : 0,
      itemsPerPage: 50,
      totalEmployees: 0,
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      employeeTableColumns: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Email ID",
          key: "email"
        },
        // {
        //   label: "Code",
        //   key: "employee_code"
        // },
        // {
        //   label: "Mobile No",
        //   key: "phoneNumber"
        // },
        {
          label: "Role",
          key: "userRole"
        },
        {
          label: "Permission",
          key: "permission"
        },
        {
          label: "Status",
          key: "is_active"
        },
        {
          label: "Action",
          key: "action"
        }
      ],
      userList: [],
      addUserAccount: false,
      statusAction: "",
      tempList:[],
      editUserRole: false,
      userRoleData: null,
      permissionViewModel: false,
      forgotPasswordUserIdentity: "",
      showResetPasswordModal: false,
      forgotPasswordErrorMessage: "",
      forgotPasswordToast: false,
    };
  },
  mounted() {
    this.getUserData();
  },
  methods: {
    ...mapActions({
      act_fetch: "auth/getUserList",
      activate_user: "auth/activateUser",
      deactivate_user: "auth/deactivateUser",
      userForgotPassword: "auth/forgotPassword",
      getSearchedEmployee: "auth/getSearchedEmployee"
    }),
    
    backToWelcomeScreen() {
      this.$emit('back');
    },

    async performAction() {
      try {
        
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
        this.getUserData();
      }
    },

    async pageCount(){
      let startEmployee = (this.currentPage - 1) * this.itemsPerPage + 1;
      let endEmployee = Math.min(this.currentPage * this.itemsPerPage, this.totalEmployees);
      this.employeePageCount = `${startEmployee}-${endEmployee}/${this.totalEmployees}` 
    },

    async getUserData() {
      let params = {
        limit: this.itemsPerPage,
        offset: this.currentPage == 1 ? this.currentPage : (this.currentPage - 1) * this.itemsPerPage
      }
      let res = await this.act_fetch(params);
      this.userList = res.data.payload.data;
      this.tempList = res.data.payload.data;
      this.totalEmployees = res.data.payload.totalEmployees;
      this.totalPages = Math.ceil(this.totalEmployees / this.itemsPerPage);
      this.pageCount();
      return this.userList;
      //console.log("Get User List", this.userList);
    },

    dropdown(slots) {
       try {
        let idx = this.userList.findIndex((obj) => {
          return obj.id == slots.id;
        });
        this.userList.forEach((data, index) => {
          if (index !== idx) {
            data.showDropDown = false;
          }
        });
        if (idx > -1) {
          this.userList[idx].showDropDown = this.userList[idx]
            .showDropDown
            ? false
            : true;
          this.userList = [...this.userList];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async activated(record) {
      let user_id = record.id;
      //console.log("User ID", user_id);
      let res = await this.activate_user({user_id:user_id});
      this.getUserData();
      //console.log("activated", res);
    },

    async deactivated(record) {
      let user_id = record.id;
      //console.log("User ID", user_id);
      let res = await this.deactivate_user({user_id:user_id});
      this.getUserData();
      //console.log("deactivated", res);
    },

    createAcc() {
      this.addUserAccount = true;
    },

    /* function to search in local by name */
    async filterData(val) {
      try {
        //let tempArray = [];
        
        // this.tempList.forEach(element => {
        //   if (element['name']) {         
        //     if (element['name'].toUpperCase().indexOf(val.toUpperCase()) > -1) {
        //       tempArray.push(element);
        //     }
        //   }
        // });
        if (val) {
          let data = await this.getSearchedEmployee(val)
          this.userList = data.data.payload;
        } else {
          let list = this.getUserData();
          this.userList = list;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    //End here

    editPermission(record) {
      this.userRoleData = record;
      this.editUserRole = true;
      //console.log("Edit Permission this.userRoleData", this.userRoleData);
    },

    viewPermission(record) {
      this.userRoleData = record;
      this.permissionViewModel = true;
      //console.log("View Permission", this.userRoleData);
    },


    /** On forgot password click  */
    onForgotPasswordClick(record) {
      this.userRoleData = record;
      try {
        this.forgotPasswordUserIdentity = this.userRoleData.email;
        this.showResetPasswordModal = true;
      } catch (err) {
        this.errmsg = err.message;
        this.toast = true;
      }
    },
    cancel() {
      this.showResetPasswordModal = false;
    },

    /** To send the an email to user to reset password  */
    async sendLink() {
      try {
        this.$root._data.isSaving = true;
        let data = await this.userForgotPassword({
          identity: this.forgotPasswordUserIdentity
        });
        if (data && data.status) {
          this.forgotPasswordErrorMessage = "";
          this.forgotPasswordToast = false;
          this.showResetPasswordModal = false;
          this.showSuccessMsg = true;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.forgotPasswordErrorMessage = err;
        this.forgotPasswordToast = true;
        this.$root._data.isSaving = false;
      }
    },

    ok() {
      this.showSuccessMsg = false;
    }        


  }
};
</script>

<style lang="scss" scoped>
.signup-form {
  width: 350px;
  background-color: #fff;
  border-radius: 4px;
  // box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.2);
  // padding: 16px 40px 25px 40px;
}
.label {
  height: 15px;
  margin-bottom: 9px;
  margin-top: 25px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.first-label {
  height: 15px;
  margin-bottom: 9px;
  font-family: Montserrat;
  font-size: 14px;
  color: #0e0e0e;
}

.signup-form .input-field {
  width: 100%;
  height: 43px;
  border-radius: 4px;
  padding: 15px 9px;
  outline: 0;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  &:focus {
    outline: none;
    border: 2px solid #34c0be;
  }
}
.signup-btn {
  margin-top: 20px;
  width: 100%;
  cursor: pointer;
  height: 45px;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  border: none;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #5d409f;
}
.signin-text {
  display: flex;
  margin-top: 15px;
  justify-content: center;
  align-items: center;
}
.signin-text div {
  height: 15px;
  font-family: Montserrat;
  font-size: 14px;
  color: #868686;
}
.signin-text a {
  text-decoration: none;
}
.phone-number {
  position: relative;
}
.phone-number span {
  position: absolute;
  right: 0;
  color: #0e0e0e;
  opacity: 0.59;
}

/* Forgot password css */
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 300px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 36px;

  .success-icon {
    margin-bottom: 40px;
  }
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
  .success-text {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: auto;
  }

  .message-text {
    font-size: 14px;
    margin-bottom: auto;
  }

  .effDateClass {
    margin-bottom: 5%;
  }
  .popup-btns {
    margin-top: 10%;
    display: flex;
    justify-content: space-between;
    a {
      /*margin-top: 4%;
      margin-left: 32%;*/
      text-align: center;
    }
  }
}
.cursor {
  cursor: pointer;
}
.forgpass {
  padding: 0px;
  .text {
    font-size: 20px;
  }
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input-field {
  width: 100%;
  height: 43px;
  border-radius: 6px;
  padding: 10px;
  outline: 0;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  &:focus {
    outline: none;
    border: 2px solid #34c0be;
  }
}
/* End here forgot password */

@media only screen and (max-width: 600px) {
  .signin-form {
    padding: 16px 20px 25px 20px;
  }
}
.errorMessage {
  color: #e01717;
  padding-top: 5px;
}

.cross-circle-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

.action-section {
  margin: 0px;
  text-align: center;
  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: -200px;
    //left: -182px;
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}

.data-table-scroll {
  overflow: scroll;
  height: 400px;
}
</style>
